import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { AdminSidebar } from "./admin-sidebar";
import { AdminTopbar } from "./admin-topbar";
import { MarketingCartFab } from "./marketing-cart-fab";

export function AdminLayout() {
	const { pathname } = useLocation();
	const [navOpen, setNavOpen] = useState(false);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	// Referme le tiroir de navigation mobile à chaque changement de route.
	useEffect(() => {
		setNavOpen(false);
	}, [pathname]);

	return (
		<div className={`app${navOpen ? "nav-open" : ""}`}>
			<AdminSidebar />
			<div
				className="nav-overlay"
				role="presentation"
				onClick={() => setNavOpen(false)}
			/>
			<main className="main">
				<AdminTopbar
					onMenuToggle={() => setNavOpen((v) => !v)}
					navOpen={navOpen}
				/>
				<div className="content">
					<Outlet />
				</div>
			</main>
			<MarketingCartFab />
		</div>
	);
}
